import { Navigate, useSearchParams } from "react-router-dom";

// Retired (2026-02, "one email door"): this generic compose page had zero quote/project
// context. Every real "Draft Email" entrypoint (Clients, Project page, Records list) now
// links straight to Quote Builder's quote-aware Draft Email panel — this redirect only exists
// so any OLD bookmark/link to /email still lands somewhere useful instead of a dead page.
export default function EmailGenerator() {
  const [params] = useSearchParams();
  const clientId = params.get("client_id");
  const projectId = params.get("project_id");
  const qs = new URLSearchParams();
  if (clientId) qs.set("client_id", clientId);
  if (projectId) qs.set("project_id", projectId);
  const suffix = qs.toString();
  return <Navigate to={`/commercial${suffix ? `?${suffix}` : ""}`} replace />;
}
